export default function cardSpecSummary({
  address,
  planName,
  squareFeet,
  bathrooms,
  bedrooms,
  garages,
  price,
  imageUrl,
  id,
  planId,
  type,
  city,
  state,
  zip,
}) {
    const attributes = `
      data-home-price="${price}"
      data-home-type="${type}"
      data-home-city="${city}"      
      data-home-state="${state}"
      data-home-zip="${zip}"
      data-home-plan-id="${planId}"      
      data-home-spec-id="${id}"      
      data-home-plan-name="${planName}"
      data-home-primary-image-url="${imageUrl}"      
    `;

    return `
      <div data-self-guided-tour-homes-item ${attributes} class="nhs-c-card--housing nhs-c-card--utour-summary">
        <picture class="nhs-c-image--width-950 nhs-mq-image--width-1480-medium">
            <source srcset="${imageUrl}?maxwidth=296&amp;format=webp&amp;progressive=true 296w,${imageUrl}?maxwidth=334&amp;format=webp&amp;progressive=true 334w,${imageUrl}?maxwidth=592&amp;format=webp&amp;progressive=true 592w,${imageUrl}?maxwidth=668&amp;format=webp&amp;progressive=true 668w" data-srcset="${imageUrl}?maxwidth=296&amp;format=webp&amp;progressive=true 296w,${imageUrl}?maxwidth=334&amp;format=webp&amp;progressive=true 334w,${imageUrl}?maxwidth=592&amp;format=webp&amp;progressive=true 592w,${imageUrl}?maxwidth=668&amp;format=webp&amp;progressive=true 668w" data-lazy-load="" type="image/webp" sizes="(max-width: 975px) 334px, 296px">
            <source srcset="${imageUrl}?maxwidth=296&amp;format=jpg&amp;progressive=true 296w,${imageUrl}?maxwidth=334&amp;format=jpg&amp;progressive=true 334w,${imageUrl}?maxwidth=592&amp;format=jpg&amp;progressive=true 592w,${imageUrl}?maxwidth=668&amp;format=jpg&amp;progressive=true 668w" data-srcset="${imageUrl}?maxwidth=296&amp;format=jpg&amp;progressive=true 296w,${imageUrl}?maxwidth=334&amp;format=jpg&amp;progressive=true 334w,${imageUrl}?maxwidth=592&amp;format=jpg&amp;progressive=true 592w,${imageUrl}?maxwidth=668&amp;format=jpg&amp;progressive=true 668w" data-lazy-load="" type="image/jpeg" sizes="(max-width: 975px) 334px, 296px">
            <img class="nhs-c-image--width-950 nhs-mq-image--width-1480-medium" src="${imageUrl}?maxwidth=296&amp;format=jpg&amp;progressive=true" data-on-error-src="https://beta-nhs-static-secure.akamaized.net/GlobalResources14/Default/images/no_images/home-card-no-photo.svg" alt="Image of ${planName} at ${address}" sizes="(max-width: 975px) 334px, 296px">
        </picture>
        <div class="nhs-c-card__body nhs-c-card__body--utour-summary" data-qa="card_body">
            <div class="nhs-c-card__content nhs-c-card__content--utour-summary">
                <p class="nhs-c-card__plan-name nhs-c-card__plan-name--utour-summary nhs_SpecPlanName">
                    ${planName}
                </p>
                <p class="nhs-c-card__price nhs-c-card__price--utour-summary" data-card-element="price">
                    <span data-qa="price_label">
                        From
                        <span>${price}</span>
                    </span>
                </p>
                <p class="nhs-c-card__facts" data-qa="card_specs">
                    ${bedrooms} Br | ${bathrooms} Ba | ${garages} Gr | ${squareFeet} sq ft
                </p>
                <h3 class="nhs-c-card__facts">
                    ${address}
                </h3>
            </div>
        </div>
    </div>`;
}
